import React from "react";
import "./Fatca.css";
import Person from "../../../../assets/images/fatca-img1.png";
import Dots from "../../../../assets/images/fatca-dots.png";
const Fatca = () => {
  return (
    <div className="fatca__section">
      <div className="fatca__slide_wrap">
        <div className="fatca__slide_bubble"></div>
        <img src={Dots} className="fatca__slide_dots" />
        <div className="fatca__slide">
          <div className="fatca__slide_left">
            <div className="fatca__slide_heading">
              <span className="fatca__slide_headingline"></span>FATCA
            </div>
            <p className="fatca__slide_description">
              As you may have heard or seen in the media, the United States
              government has ramped up its efforts to combat tax evasion through
              a law known as FATCA. The law has significantly influenced the
              information reporting relationships between the U.S. and foreign
              governments. The law also has practical tax compliance
              implications for U.S. expats, including the requirement to file
              FATCA Form 8938.
            </p>
            <button className="fatca__slide_button">View More</button>
          </div>
          <div className="fatca__slide_right">
            <img src={Person} alt="" className="fatca__slide_image" />{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fatca;
